export default __webpack_public_path__ + "static/media/ProductSans-Thin.f8415cc2.ttf";